import { useQuery } from '@tanstack/react-query';

import { EventsService } from '../services';

const key = 'lep';

export const useLepQuery = (eventId: number) => {
  const queryKey = [key, eventId];

  const queryFn = () => EventsService.getLEPAnalysis(eventId);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!eventId,
  });
};
